// Sing in Solfège's colours (issue #3722), from the "Sing in Solfège (listen)", "(sing along)" and
// "(result)" artboards. The greys, the dark of a played note and the accent purple are the app's
// theme variables, as Interval Training's staff uses them, so they flip with the theme; the result
// colours are fixed hex like every Learn result colour (learn_colors.ts, pitch_colors.ts) and stay
// themselves in dark mode. The artboards' close colour is a darker amber than the result squares'
// yellow, because here it is a thin line and small type on the page, not a filled square.

import { ResultColor } from '../../../../../common/src/rhythm_echo.ts';
import { resultColorCss } from '../learn_colors.ts';
import { pitchLockedGreen } from '../pitch/pitch_colors.ts';
import { SolfegeNoteDisplay } from './solfege_session.ts';

export const solfegeCloseAmber = '#c99400';

const accentPurple = 'var(--color-tab-selected)';
const playedDark = 'var(--color-text)';

// On pitch, close and missed: a graded note, the trace and the result's legend
export const solfegeResultColorCss: Record<ResultColor, string> = {
  green: pitchLockedGreen,
  yellow: solfegeCloseAmber,
  red: resultColorCss.red,
};

// A note's colour on the staff, by its state: grey still to come (the tab bar's unselected grey,
// which recedes on either background), purple as it sounds or is sung, dark once played, and its
// grade's colour once graded. A passing note, never graded, stays the plain dark of a played note.
export const solfegeNoteColors: Record<SolfegeNoteDisplay, string> = {
  upcoming: 'var(--color-tab-label-unselected)',
  current: accentPurple,
  played: playedDark,
  passing: playedDark,
  ...solfegeResultColorCss,
};

// A syllable's colour: its note's, but a syllable still to come is the page's label grey, which
// reads as type
export const solfegeSyllableColors: Record<SolfegeNoteDisplay, string> = {
  ...solfegeNoteColors,
  upcoming: 'var(--color-text-darker)',
};

// The dot while no voice is heard: a hollow ring in the upcoming notes' grey
export const solfegeQuietDotColor = 'var(--color-tab-label-unselected)';

// The playhead during "Hear mine"
export const solfegePlayheadColor = accentPurple;
